export default {
    MESH_EVENTS : Object.freeze({
        GET_TOKEN : "GET_TOKEN",
        GET_TOKEN_V2: "GET_TOKEN_V2",
        PRINT_SAL: "PRINT_SAL",
        SET_SAL_FORMAT: "SET_SAL_FORMAT",
        DESTROY: "DESTROY",
        AVERY_SCAN: "AVERY_SCAN",
        SET_VERIFICATION_TOKEN: "SET_VERIFICATION_TOKEN",
        GET_VERIFICATION_TOKEN: "GET_VERIFICATION_TOKEN",
        VALIDATE_VERIFICATION_TOKEN: "VALIDATE_VERIFICATION_TOKEN",
        AVERY_SCAN_WITH_COLOR: "AVERY_SCAN_WITH_COLOR",
        AVERY_ERROR: "AVERY_ERROR",
        ZEBRA_CREATE_CONNECTION: "ZEBRA_CREATE_CONNECTION",
        ZEBRA_CLOSE_CONNECTION: "ZEBRA_CLOSE_CONNECTION",
        ZEBRA_PRINT_LABEL: "ZEBRA_PRINT_LABEL",
        ZEBRA_PRINTER_STATUS: "ZEBRA_PRINTER_STATUS",
        ZEBRA_PRINTER_RESOLUTION: "ZEBRA_PRINTER_RESOLUTION",
        GET_AVERY_CONNECTION_STATUS: "GET_AVERY_CONNECTION_STATUS",
        AVERY_CHANGE_PRINTER: "AVERY_CHANGE_PRINTER",
        ZEBRA_CREATE_USB_CONNECTION: "ZEBRA_CREATE_USB_CONNECTION",
        AVERY_DISCONNECT:"AVERY_DISCONNECT",
        LOGOUT_USER: "LOGOUT_USER",
        HELP_REQUEST_NOTIFICATION_RECEIVED: "HELP_REQUEST_NOTIFICATION_RECEIVED",
        UPDATE_HELP_REQUEST_NOTIFICATION_STATUS: "UPDATE_HELP_REQUEST_NOTIFICATION_STATUS",
        UPDATE_HELP_REQUEST_NOTIFICATION_BELL_STATUS: "UPDATE_HELP_REQUEST_NOTIFICATION_BELL_STATUS",
        GET_HELP_REQUEST_NOTIFICATION_BELL_STATUS: "GET_HELP_REQUEST_NOTIFICATION_BELL_STATUS",
        STORE_HORUS_VIDEO: "STORE_HORUS_VIDEO",
        SMART_GLASSES_SCAN: "SMART_GLASSES_SCAN",
        AUDIO_NOTIFICATION: "AUDIO_NOTIFICATION",
        // PWA -> native: service worker precached the app shell; native records it as the offline launch target.
        SHELL_CACHED: "SHELL_CACHED",
        // native -> PWA push on every offline-mode transition; also the reply to GET_OFFLINE_MODE.
        // Payload = the native OfflineModeState JSON (state, stationCode, alias, traceId, ...).
        OFFLINE_MODE_CHANGED: "OFFLINE_MODE_CHANGED",
        // PWA -> native pull for the current offline-mode state (sent at boot; the push has no replay).
        GET_OFFLINE_MODE: "GET_OFFLINE_MODE"
    })
}
